<template>
  <div class="info-tiles-container">
    <h1 v-if="!alternativeTitle">
      <span>Why create your will</span> with Old Mutual?
    </h1>
    <h1 v-else v-html="alternativeTitle"></h1>
    <InfoTiles :tiles="tiles" />
    <div
      v-if="additionalText"
      v-html="additionalText"
      class="additional-text"
    ></div>
    <div v-if="buttonText" class="info-tiles-button-container">
      <GradientButton
        :title="buttonText"
        @gradientButtonClicked="$emit('gradientButtonClicked')"
      />
    </div>
  </div>
</template>

<script>
  import InfoTiles from './InfoTiles.vue';

  export default {
    name: 'InfoTilesContainer',
    components: {
      InfoTiles,
    },
    props: {
      tiles: {
        required: true,
        default: [],
        type: Array,
      },
      alternativeTitle: {
        default: '',
        type: String,
      },
      additionalText: {
        default: '',
        type: String,
      },
      buttonText: {
        default: '',
        type: String,
      },
    },
  };
</script>

<style scoped lang="scss">
  .info-tiles-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    z-index: 14;
    position: relative;
    h1 {
      font-size: 28px;
      font-weight: 300;
      line-height: 34px;
      letter-spacing: -0.0025em;
      text-align: center;
      margin-bottom: 10px;

      span {
        font-size: 28px;
        font-weight: 500;
        line-height: 34px;
        letter-spacing: -0.0025em;
        text-align: center;
      }
    }
    h2 {
      font-size: 16px;
      font-weight: 400;
      line-height: 22px;
      text-align: center;
      margin-bottom: 33px;
      color: #747474;
    }
    .additional-text {
      max-width: 60%;
      margin: 0 auto;
      text-align: center;
      font-size: 22px;
      line-height: 28px;
    }

    .info-tiles-button-container {
      margin-top: 30px;
      display: flex;
      justify-content: center;
    }
  }
  @media (max-width: 768px) {
    .info-tiles-container {
      .additional-text {
        max-width: 85dvw;
      }
    }
  }
</style>
